import ErrorUi from 'client/components/core/Error/ui/ErrorUi'
import InputUi from 'client/components/core/Sidebar/components/Settings/components/Input/ui/InputUi'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'

interface InputProps {
  label?: string
  helpMessage?: string
  update: (value: string) => void
  value?: string | number
  placeholder?: string
  type?: string
  onBlur?: () => void
  itemStyles?: React.CSSProperties
  error?: string
  disabled?: boolean
  isResetIconVisible?: boolean
  onReset?: () => void
  removeWhitespaces?: boolean
}

const Input = ({
  label,
  helpMessage,
  update,
  value,
  placeholder,
  type,
  onBlur,
  itemStyles,
  error,
  disabled = false,
  isResetIconVisible = false,
  removeWhitespaces,
  onReset,
}: InputProps) => {
  const { t } = useTranslation()
  return (
    <OptionWrapper
      labelText={label}
      helpMessage={helpMessage}
      itemStyles={itemStyles}
      isResetIconVisible={isResetIconVisible}
      onReset={onReset}
    >
      <InputUi
        onChange={e =>
          update(
            removeWhitespaces
              ? e.target.value.replace(/\s/g, '')
              : e.target.value,
          )
        }
        value={value}
        placeholder={placeholder ? t(placeholder) : ''}
        type={type}
        onBlur={onBlur}
        disabled={disabled}
      />
      {error ? <ErrorUi dangerouslySetInnerHTML={{ __html: error }} /> : null}
    </OptionWrapper>
  )
}

export default Input
